export function replaceGuillemets(value: string) {
  return value.replace(/\\+(<<|>>|<|>)|(<<|>>|‹<|›>|<|>)/g, (_match, escaped: string | undefined, unescaped: string | undefined) => {
    if (escaped) return escaped;
    return ({ '<<': '«', '>>': '»', '‹<': '«', '›>': '»', '<': '‹', '>': '›' } as Record<string, string>)[unescaped!]!;
  });
}

function transformedCursorPosition(value: string, offset: number) {
  return replaceGuillemets(value.slice(0, offset)).length;
}

function isSupportedTextControl(target: EventTarget | null): target is HTMLInputElement | HTMLTextAreaElement {
  if (target instanceof HTMLTextAreaElement) return !target.readOnly && !target.disabled;
  return target instanceof HTMLInputElement && target.type !== 'password' && !target.readOnly && !target.disabled;
}

export function installGuillemetsAutoreplace() {
  document.addEventListener('input', (event) => {
    if ((event instanceof InputEvent && event.isComposing) || !isSupportedTextControl(event.target)) return;
    const control = event.target;
    const value = control.value;
    const next = replaceGuillemets(value);
    if (next === value) return;
    const start = control.selectionStart;
    const end = control.selectionEnd;
    control.value = next;
    if (start !== null && end !== null) control.setSelectionRange(transformedCursorPosition(value, start), transformedCursorPosition(value, end));
  }, true);
}
